import cx from 'classnames';
import {
  CaptionTextarea,
  useCaptionState,
} from 'lib-knowledge-document-structure/plate/caption';
import { MyImageElement } from 'lib-knowledge-document-structure/plateTypes';

import s from './caption.module.scss';

type CaptionProps = {
  align: MyImageElement['imgAlign'];
};

export function Caption({ align }: CaptionProps): JSX.Element {
  const { captionString, selected, readOnly } = useCaptionState({});

  if (!captionString.length && (readOnly || !selected)) {
    return <></>;
  }

  const className = cx(s.caption, {
    [s['stretch']]: align === 'stretch',
    [s['center']]: align === 'center',
    [s['end']]: align === 'end',
    [s['start']]: align === 'start',
  });

  return (
    <figcaption>
      <CaptionTextarea
        className={className}
        placeholder="Add a caption...."
        readOnly={readOnly}
      />
    </figcaption>
  );
}
